import { componentFactory } from '@fusioncharts/core/src/lib';
import LimitUpdater from '@fusioncharts/core/src/axis/limit-updater';
export default function (chart) {
  let numericAxis = chart.getChildren('yAxis')[0],
    limitUpdaterArr,
    limitUpdater;
  componentFactory(numericAxis, LimitUpdater, 'limitUpdater', chart.config.allowAxisChange ? 1 : 0);
  limitUpdaterArr = numericAxis.getChildren('limitUpdater');
  limitUpdater = limitUpdaterArr && limitUpdaterArr[0];
  limitUpdater && limitUpdater.configure();
}
